import { useLocationQuery } from '@web/helpers/hooks';
import { useLocation } from 'react-router';

export type TimesheetViewKind = 'my' | 'staff' | 'crew';

export const useTimesheetViewKind = (): TimesheetViewKind => {
  const { pathname: path } = useLocation();
  const query = useLocationQuery();

  if (path.startsWith('/crew-timesheets')) return 'crew';
  if (path.startsWith('/staff-timesheets') || path.startsWith('/staff-time-clocks') || query.get('staff') === 'true') return 'staff';

  return 'my';
};

export const useIsStaff = () => {
  return useTimesheetViewKind() === 'staff';
};

export const useIsCrew = () => {
  return useTimesheetViewKind() === 'crew';
};
